import { css } from '@emotion/react';
import COLORS from 'shared/styles/colors';
import theme from 'shared/styles/themes';
import { zIndex } from 'shared/config';

export default css({
  '&.multi-page-layout': {
    position: 'relative',

    '&__side-nav-item': {
      display: 'flex',
      backgroundColor: COLORS.NEUTRAL100,
      border: `1px solid ${COLORS.NEUTRAL200}`,
      borderRadius: '3px',
      alignItems: 'center',
      padding: theme.space[4],
      minHeight: '50px',
      marginBottom: theme.space[3],
      '&--active': {
        backgroundColor: COLORS.NEUTRAL0,
      },
      '&--error': {
        border: `1px solid ${COLORS.RED500}`,
      },
    },
    '&__grid-content': {
      gridColumn: 'content-start / content-end',
      gridRow: 'row-content-start / end',
    },
    '&__grid-content--no-header': {
      gridRow: 'header-start / end',
    },
  },
  '.multi-page-layout': {
    '&__side-nav': {
      flexDirection: 'column',
    },
    '&__main-content': {
      display: 'grid',
      gridTemplateColumns: '[panels-start] 1fr [content-start] 3fr [content-end]',
      gridTemplateRows: `[header-start] 75px [row-content-start] auto [end]`,
      columnGap: theme.space[6],
      gridAutoRows: '50px',
    },
    '&__header': {
      gridColumn: 'panels-start / content-end',
      gridRow: 'header-start / row-content-start',
      position: 'sticky',
      width: '100%',
      top: 0,
      right: 0,
      left: 0,
      alignItems: 'center',
      justifyContent: 'space-between',
      zIndex: zIndex.zStickyElements,
      backgroundColor: COLORS.PRIMARY25,
    },
    '&__brief-form-btns': {
      alignItems: 'center',
      gap: theme.space[3],
    },
    '&__page-content': {
      backgroundColor: COLORS.NEUTRAL0,
      border: `1px solid ${COLORS.NEUTRAL200}`,
      borderRadius: '8px',
      padding: theme.space[7],
      flexDirection: 'column',
      justifyContent: 'space-between',
      overflowY: 'auto',
      minHeight: '20rem',
      maxHeight: '100%',
    },
    '&__title': {
      color: COLORS.NEUTRAL600,
    },
    '&__title-icon': {
      paddingRight: theme.space[3],
      color: COLORS.NEUTRAL600,
    },
    '&__error-icon': {
      marginLeft: 'auto',
      color: COLORS.RED500,
    },
    '&__btn-wrapper': {
      position: 'relative',
      height: '30px',
      marginTop: theme.space[6],
    },
    '&__prev-btn': {
      position: 'absolute',
      left: 0,
      bottom: 0,
    },
    '&__next-btn': {
      position: 'absolute',
      right: 0,
      bottom: 0,
    },
  },
});
